import Vue from 'vue';
import Router from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import HomePage from '@/views/HomePage.vue';


Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect:'/home', // Home
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/SelectMerchant',
    name: 'SelectMerchant',
    component:() => import('@/views/SelectMerchant.vue'),
  },
  {
    path: '/BillDetails',
    name: 'BillDetails',
    component:() => import("@/views/BillDetails.vue")
  },
  {
    path: '/BillDetailsSelectPage',
    name: 'BillDetailsSelectPage',
    component:() => import("@/views/BillDetailsSelectPage.vue")
  },

];

const router = new Router({
  mode: 'history',
  routes
});

export default router;
